import React, { useEffect, useState } from "react";
import "./GymGallery.css";
import { useNavigate } from "react-router-dom";
import { getPackages } from "../../Services/Operations/ProductAPI";

const images = [
  { id: 1, category: "workout", src: "https://images.unsplash.com/photo-1517836357463-d25dfeac3438" },
  { id: 2, category: "equipment", src: "https://images.unsplash.com/photo-1583454110551-21f2fa2afe61" },
  { id: 3, category: "training", src: "https://images.unsplash.com/photo-1558611848-73f7eb4001a1" },
  { id: 4, category: "workout", src: "https://images.unsplash.com/photo-1579758629938-03607ccdbaba" },
  { id: 5, category: "equipment", src: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48" },
  { id: 6, category: "training", src: "https://images.unsplash.com/photo-1517838277536-f5f99be501cd" },
  { id: 7, category: "workout", src: "https://images.unsplash.com/photo-1599058917765-a780eda07a3e" },
  { id: 8, category: "equipment", src: "https://images.unsplash.com/photo-1594737625785-a6cbdabd333c" },
];

const GymGallery = () => {
    const navigate = useNavigate();

  const [filter, setFilter] = useState("all");

  const filteredImages =
    filter === "all"
      ? images
      : images.filter((img) => img.category === filter);


      const handleGetPackages=async()=>{
        try {
          const res= await getPackages()
          console.log(res);
          
        } catch (error) {
          console.log(error);
          
        }
      }

      useEffect(() => {
       handleGetPackages()
      }, [])
      

  return (
    <div className="gym-gallery-wrapper">
              {/* BACK BUTTON */}
      <button
        className="dd-back-btn"
        onClick={() => navigate('/')}
      >
        ← Back
      </button>

      {/* HERO */}
      <div className="gym-gallery-hero">
        <h1>Burnout Gym Gallery</h1>
        <p>Explore our training sessions, modern equipment and gym moments</p>
      </div>

      {/* FILTER */}
      <div className="gym-gallery-filter">

        <button
          onClick={() => setFilter("all")}
          className={filter === "all" ? "active" : ""}
        >
          All
        </button>

        <button
          onClick={() => setFilter("workout")}
          className={filter === "workout" ? "active" : ""}
        >
          Workout
        </button>

        <button
          onClick={() => setFilter("equipment")}
          className={filter === "equipment" ? "active" : ""}
        >
          Equipment
        </button>

        <button
          onClick={() => setFilter("training")}
          className={filter === "training" ? "active" : ""}
        >
          Training
        </button>

      </div>

      {/* GALLERY GRID */}

      <div className="gym-gallery-grid">

        {filteredImages.map((img) => (
          <div className="gym-gallery-card" key={img.id}>

            <img src={img.src} alt="gym"/>

            <div className="gallery-overlay">
              <h3>Burnout Gym</h3>
              <p>{img.category}</p>
            </div>

          </div>
        ))}

      </div>

    </div>
  );
};

export default GymGallery;